webpackJsonp([15],{

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(225)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(179),
  /* template */
  __webpack_require__(252),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'silentplace',
  metaInfo: {
    title: 'Silent place to work in downtown of Bratislava'
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(99)(true);
// imports


// module
exports.push([module.i, ".button.is-black.is-block.is-large.meeting{background-image:-webkit-gradient(linear,left bottom,right top,from(#b60cf6),color-stop(#9316e5),color-stop(#711ad4),color-stop(#4c1ac1),to(#1e19ae));background-image:-webkit-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:-o-linear-gradient(left bottom,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae);background-image:linear-gradient(to right top,#b60cf6,#9316e5,#711ad4,#4c1ac1,#1e19ae)}.notification{padding:0}", "", {"version":3,"sources":["/opt/build/repo/cowork-panel/src/components/SilentPlace.vue"],"names":[],"mappings":"AACA,2CACE,sJAA8J,AAC9J,8FAAoG,AACpG,yFAA+F,AAC/F,sFAA6F,CAC9F,AACD,cACA,SAAW,CACV","file":"SilentPlace.vue","sourcesContent":["\n.button.is-black.is-block.is-large.meeting {\n  background-image: -webkit-gradient(linear, left bottom, right top, from(#b60cf6), color-stop(#9316e5), color-stop(#711ad4), color-stop(#4c1ac1), to(#1e19ae));\n  background-image: -webkit-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: -o-linear-gradient(left bottom, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n  background-image: linear-gradient(to right top, #b60cf6, #9316e5, #711ad4, #4c1ac1, #1e19ae);\n}\n.notification {\npadding: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(201);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(100)("5aedea36", content, true, {});

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "silentplace"
  }, [_c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent is-4"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/focus_room_cat_view.jpg",
      "alt": "focus room coworking bratislava"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-4"
  }, [_c('article', {
    staticClass: "tile is-child"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/cowork/focus_room_corner_call_room.jpg",
      "alt": "focus room coworking bratislava"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent is-size-4"
  }, [_c('article', {
    staticClass: "tile is-child notification is-black"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("🎯🧠 Silent Place to Work in Bratislava")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("📍 Downtown location")]), _vm._v(" "), _c('p', [_vm._v("👩‍🎨 Creative environment")]), _vm._v(" "), _c('p', [_vm._v("📚 Knowledge rich community")]), _vm._v(" "), _c('p', [_vm._v("🧠 Perfect for brainstorming")]), _vm._v(" "), _c('p', [_vm._v("🎧 Accoustic insulated space")]), _vm._v(" "), _c('p', [_vm._v("🙏 Perfect for Team Collaborations")]), _vm._v(" "), _c('p', [_vm._v("🤙 Great for international video conference hangouts")]), _vm._v(" "), _c('p', [_vm._v("💞 By renting our cowork you are supporting our community ")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-container"
  }, [_c('a', {
    staticClass: "button is-black is-block is-large meeting",
    attrs: {
      "href": "mailto:info@progressbar.sk?subject=I want to try Progressbar Cowork!"
    }
  }, [_vm._v("\n            I want to try Cowork\n          ")])])])])])])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/15.845f634e8abd0d4888b7.js